export default __webpack_public_path__ + "static/B0238-f7ad339e4ff6aa9fe273d63b64104384.png";